import { CompanyHomeThemeModeConfig } from './types';

const light: CompanyHomeThemeModeConfig = {
  companyHome: {},
};

export default light;
